<template>
  <div class="event-warning" redesign>
    <!-- Request stepper -->
    <RequestStepProgressBar step4 />

    <div class="form-container event-warning-form">
      <h4 v-translate>Are you sure you want to skip documentation?</h4>
      <p v-translate>
        You can return later to upload documentation, but you are required to provide supporting
        documentation for at least one event prior to submitting your request.
      </p>
    </div>
    <div class="button-container">
      <button class="form-button white-button" @click="handleGoBack">
        <span v-translate>Go Back</span>
      </button>
      <button class="form-button" @click="hanldeUploadLater">
        <span v-translate>Upload Later</span>
      </button>
    </div>
  </div>
</template>

<script>
import { analyticsMixin } from '@/services/googleAnalytics'
import RequestStepProgressBar from '@/components/stepper/RequestStepProgressBar'

export default {
  name: 'EventWarning',
  mixins: [analyticsMixin],
  components: { RequestStepProgressBar },
  methods: {
    handleGoBack() {
      this.trackClickedCTA('go back')
      this.$router.push({ name: 'EventDocumentation' })
    },
    hanldeUploadLater() {
      this.trackClickedCTA('upload later')
      this.$router.push({ name: 'ExpenseCategories' })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';
@import '@/styles/mixins/responsive';

.event-warning {
  display: flex;
  flex-direction: column;

  .event-warning-form {
    @extend .constrain-tablet-and-up;
  }
}
</style>
